import { render } from "./mortgagetools.vue?vue&type=template&id=50a54d6d"
import script from "./mortgagetools.js?vue&type=script&lang=js"
export * from "./mortgagetools.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__